import React, { Component } from 'react';
import { PrimaryButton } from '@fluentui/react';

export class Plans extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }




    render() {
        return (
            <div>
                <div className="displayflex">
                    <div class="card box price-wrap">

                        <div class="card-block p-b-30">
                            <h5 style={{ margin: '10px 0 5px' }}>
                                Monthly
                        </h5>
                            <div class="pricing_plan--price">
                                <span class="pricing">
                                    <sup>USD</sup>
                                    <sup class="dollar_sign">$</sup>
                                    99
                            </span>
                            </div>
                            <div class="pricing_plan--term">Per month / Billed monthly</div>

                            <PrimaryButton
                                text={'Get started'}
                                style={{ height: 38 }}
                                className="action-btn"
                                onClick={e => this.props.changeStep('checkout', 'monthly')}
                            />
                        </div>
                    </div>
                    <div class="card box price-wrap m-l-30" style={{ 'marginLeft': '30px' }}>

                        <div class="card-block p-b-30">
                            <h5 style={{ margin: '10px 0 5px' }}>
                                Annually
                            </h5>
                            <div class="pricing_plan--price">
                                <span class="pricing">
                                    <sup style={{ left: '-35px' }}>USD</sup>
                                    <sup class="dollar_sign" style={{ left: '-5px' }}>$</sup>
                                    1,069
                            </span>
                            </div>
                            <div class="pricing_plan--term">BILLED ANNUALLY</div>
                            <div class="pricing_plan--save" style={{ 'marginTop': '-15px' }}>Save 10% with Annual</div>
                            <PrimaryButton
                                text={'Get started'}
                                style={{ height: 38 }}
                                className="action-btn"
                                onClick={e => this.props.changeStep('checkout', 'annually')}
                            />
                        </div>
                    </div>

                </div>
                <p style={{
                    margin: '20px 0px 20px', textAlign: 'center', display: 'inline-block', width: '100%'
                }}>All plans are priced per facility.</p>
            </div>
        );
    }
}

export default (Plans);





